import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, vModelText as _vModelText, createCommentVNode as _createCommentVNode, vShow as _vShow, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/apply/img-file-upload.svg'
import _imports_1 from '@/assets/img/apply/icon-checked.svg'
import _imports_2 from '@/assets/img/common/img-pagetop.svg'


const _withScopeId = n => (_pushScopeId("data-v-622c1fcc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "l-wrapper",
  style: {"background-color":"#e6eff6"}
}
const _hoisted_2 = { class: "l-wrapper_main" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "応募確認", -1))
const _hoisted_4 = { class: "p-apply" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "p-apply_headingLv1 u-mn-hidden" }, "応募確認", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-apply_text" }, [
  /*#__PURE__*/_createTextVNode(" 志望度や志望理由があれば教えてください。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ご入力いただいた内容は企業へ共有いたしません。 ")
], -1))
const _hoisted_7 = { class: "p-apply-card" }
const _hoisted_8 = { class: "p-apply-card_heading" }
const _hoisted_9 = { class: "p-apply_label-radio" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "現時点での志望度", -1))
const _hoisted_11 = ["name", "value"]
const _hoisted_12 = { class: "label-number" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "低い", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "高い", -1))
const _hoisted_15 = { class: "p-apply_label-select" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "0" }, "志望理由（任意）", -1))
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "p-apply_textarea" }
const _hoisted_19 = { class: "p-apply_button-wrap" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-apply_button" }, "応募する", -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  class: "c-modal js-modal-container",
  id: "apply"
}
const _hoisted_23 = {
  class: "c-modal_inner",
  style: {"max-width":"400px"}
}
const _hoisted_24 = { class: "c-modal_content" }
const _hoisted_25 = { class: "js-apply-tab" }
const _hoisted_26 = { class: "p-apply-modal" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-apply-modal_img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_28 = {
  key: 0,
  class: "p-apply-modal_heading"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = { class: "js-apply-tab" }
const _hoisted_32 = { class: "p-apply-modal" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "p-apply-modal_img" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "p-apply-modal_heading" }, [
    /*#__PURE__*/_createTextVNode(" 1件の応募を "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 受け付けました ")
  ])
], -1))
const _hoisted_34 = { class: "p-apply-modal_text" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "c-modal_bg" }, null, -1))
const _hoisted_36 = { class: "l-wrapper_nav" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_39 = [
  _hoisted_38
]

import { onBeforeUnmount, ref } from 'vue';
import { onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { OrderApply, OrderInfo, UpdateResponse } from '@/types';
import { getShintyokuNoSrc2Service, submitUpdateApplyShintyokuService } from '@/api/services/shintyokuService';
import { getOrderInfoById } from '@/api/shintyokuEndpoint';
import { TrnShintyokuSelectRequest } from '@/types/request';
import Loading from '@/components/Loading.vue';
import { MYPAGE_CONSTANTS } from '@/constants/mypage';
import { MstMyPageItem } from '@/types/mstMyPage';
import store from '@/store';
import { domHelperUtils } from '@/utils/domHelper';
import { triggerGTMEvent } from '@/utils/gtmEventHelper';


export default /*#__PURE__*/_defineComponent({
  __name: 'ApplyFormView',
  setup(__props) {

// src/js/_module/_p-apply.ts
const storeBase = MYPAGE_CONSTANTS.STORE_MST;

// Master data
const mstApplyList = ref<MstMyPageItem[]>([]);
const orderInfo = ref<OrderInfo>();
const companyNameAndJobTitle = ref('');
const PARAMS_ALLOW_ACCESS_PAGE = ['jobSearch', 'public', 'reApply'];

// Form Data
const applyIdValue = ref<number>(0);
const applyLevelValue = ref<number>(3); // DEFAULT CHECKED (3)
const applyReasonValue = ref<string>('');

// Modal Events
const showModal = ref(false);
const isConfirmed = ref(false);
const btnClose = ref(true);
const errorMessage = ref('');
const submitSuccess = ref(false);
const canApplyPublicJob = ref(false);
const isLoading = ref<boolean>(false);

function scrollToTop() {
  domHelperUtils.scrollToTop();
}

const handleBack = () => {
  window.history.back();
};

// Events
const handleShow = (isShow: boolean) => {
  showModal.value = isShow;
  btnClose.value = !isShow;
};

const handleSubmitApply = async () => {
  if (isConfirmed.value) {
    resetValueRef();
    return;
  }
  handleShow(false);
  isLoading.value = true;
  // Add value for request
  const orderApplyParams : OrderApply[] = [{
    orderId: Number(orderId),
    applyId: applyIdValue.value,
    aspiration: applyLevelValue.value,
    applyReason: applyReasonValue.value,
  }];
  // 応募する(※公開求人の場合)
  const isPublicJobTab = screenName === 'public';
  const isReApply = !isPublicJobTab && screenName === 'reApply';
  canApplyPublicJob.value = isPublicJobTab && await checkOrderCanApplyPublicJob(orderInfo.value?.orderId || null);
  // Send Request
  const response = await submitUpdateApplyShintyokuService(orderApplyParams, false, canApplyPublicJob.value, isPublicJobTab, isReApply);
  handleShowMessage(response);
};

/**
 * Reset default value of Ref
 */
const resetValueRef = () => {
  showModal.value = false;
  isConfirmed.value = false;
  btnClose.value = true;
  errorMessage.value = '';
  submitSuccess.value = false;
  isLoading.value = false;
  document.body.style.overflow = '';
};

const handleLeaveForm = () => {
  if (submitSuccess.value) {
    router.push('/apply/');
    return;
  }
  resetValueRef();
};

const handleClickOutSideModal = (event: Event) => {
  const target = event.target as Element | null;
  // Check if the click was inside the model-confirm-form div
  if (target && !target.closest('.c-modal_inner') && submitSuccess.value) {
    router.push('/apply/');
    return;
  }
};

/*
 * Handles the display of messages based on the response from an update operation.
 * @param response - The response object from the update operation, or null if no response is available.
 */
const handleShowMessage = (response: UpdateResponse | null) => {
  // Check if the response is null and handle the null case if needed
  if (!response) {
    // If there's no response, exit the function early
    return;
  }
  // Check for ignored orders and set an error message if any are found
  if ((response.ignoreOrders ?? []).length > 0) {
    errorMessage.value = handleMessageForInvalidOrders(MYPAGE_CONSTANTS.STRING.IGNORED_ORDER_ERR_MESG_SINGLE);
  }

  // Check for unapproved orders and set an error message if any are found
  if ((response.unApprovedOrders ?? []).length > 0) {
    errorMessage.value = handleMessageForInvalidOrders(MYPAGE_CONSTANTS.STRING.NO_ACCESS_RIGHTS);
  }

  // Check for unavailable orders and set an error message if any are found
  if ((response.unAvailableOrders ?? []).length > 0) {
    errorMessage.value = handleMessageForInvalidOrders(MYPAGE_CONSTANTS.STRING.NO_SEL_ON_BRIEFING_SESSION);
  }

  // Check for re-apply denied orders and set an error message if any are found
  if ((response.reApplyDeniedOrder ?? []).length > 0) {
    errorMessage.value = handleMessageForInvalidOrders(MYPAGE_CONSTANTS.STRING.REAPPLY_DENY_MESG);
  }

  // Check for shintyoku and set an error message if any are found
  if (typeof response.shintyokuNotFoundException === 'string' && response.shintyokuNotFoundException.length > 0) {
    errorMessage.value = handleMessageForInvalidOrders(MYPAGE_CONSTANTS.STRING.NO_SEARCH_RESULTS_MSG);
  }

  // Check for shintyoku update exception and set an error message if any are found
  if (typeof response.shintyokuUpdateException === 'string' && response.shintyokuUpdateException.length > 0) {
    errorMessage.value = handleMessage(MYPAGE_CONSTANTS.STRING.FAIL_UPDATE_PROGRESS_MSG);
  }

  // Check for other exceptions and set an error message if any are found
  if (typeof response.otherException === 'string' && response.otherException.length > 0) {
    errorMessage.value = handleMessage(MYPAGE_CONSTANTS.STRING.FAIL_REGISTER_PROGRESS_HISTORY_MSG);
  }
  // Check for order apply for public exceptions and set an error message if any are found
  if (typeof response.orderPublicApplyException === 'string' && response.orderPublicApplyException.length > 0) {
    errorMessage.value = handleMessage(MYPAGE_CONSTANTS.STRING.NO_AVAILABLE_JOB_MSG);
  }
  // Check for order apply for public search exceptions and set an error message if any are found
  if (typeof response.orderPublicApplySearchException === 'string' && response.orderPublicApplySearchException.length > 0) {
    errorMessage.value = handleMessageForInvalidOrders(MYPAGE_CONSTANTS.STRING.INTRODUCED_CONTACT_DESCRIPTION);
  }

  // Determine whether to show a confirmation or success message
  if (errorMessage.value.length > 0) {
    // If there is an error message, set the confirmation flag
    isConfirmed.value = true;
  } else {
    // If there are no error messages, set both confirmation and success flags
    isConfirmed.value = true;
    submitSuccess.value = true;
    document.body.style.overflow = '';
  }
  isLoading.value = false;
  handleShow(true);
};

/**
 * Generates a formatted message for invalid orders.
 *
 * @param msg - The base message to be displayed.
 * @returns A formatted string containing all provided details.
 */
const handleMessageForInvalidOrders = (msg: string): string => {
  // Build and return the full message
  return `${msg}<br/>${orderId} : ${companyNameAndJobTitle.value}`;
};

/**
 * Generates a formatted message.
 *
 * @param msg - The base message to be displayed.
 * @returns A formatted string containing all provided details.
 */
const handleMessage = (msg: string): string => {
  return msg;
};

// Route => Get Params
const route = useRoute();
const router = useRouter();
const orderId = route.params.orderId as string;
const screenName = route.params.screenName as string;

onMounted(async () => {
  const orderIdParam = Number(orderId);
  if (isNaN(orderIdParam)) {
    router.replace({ path: 'mynavi/404' });
    return;
  }
  // Check invalid params from URL
  if (!PARAMS_ALLOW_ACCESS_PAGE.includes(screenName)) {
    router.replace({ path: 'mynavi/404' });
  }

  mstApplyList.value = await store.dispatch(storeBase.MST_APPLY);
  checkOrderByAccessScreen();
  const orderInfoResponse = await getOrderInfoById(orderIdParam);
  if (orderInfoResponse != null && orderInfoResponse.responseFault.responseId === 'N003') {
    router.replace({ path: 'mynavi/404' });
  } else {
    if (orderInfoResponse.detail != null) {
      orderInfo.value = orderInfoResponse.detail;
      companyNameAndJobTitle.value = orderInfo.value.clientName + '／' + orderInfo.value.positionname;
    }
  }

  document.addEventListener('click', handleClickOutSideModal);

  // Push job detail data to GTM for analytics tracking
  const isPublic = screenName === 'public';
  const isBooster = false; // Booster Order haven't approve button
  await triggerGTMEvent(orderId, isPublic, isBooster);
});

/**
 * Checks if an order is eligible to apply for a public job. 
 * 応募する(※公開求人の場合)
 *
 * @param orderId - The ID of the order to check.
 * @returns A promise that resolves to true if the order meets all criteria, otherwise false.
 */
const checkOrderCanApplyPublicJob = async (orderId: number | null): Promise<boolean> => {
  // If orderId is null or invalid, immediately return false
  if (!orderId) {
    return false;
  }

  // Retrieve order information by ID
  const orderResponse = await getOrderInfoById(orderId);

  // Validate that the order details exist
  if (orderResponse && orderResponse.detail) {
    // Eligible anonymity flags
    const anonymityintNums: string[] = ['1', '2'];
    // Check if all required conditions are met
    // Anonymity flag is '1' or '2
    // Registration status is 2
    // Approval status is 5
    return (anonymityintNums.includes(orderResponse.detail.anonymityintFlg) && orderResponse.detail.regstatusId === 2 && orderResponse.detail.approvedstatusId === 5);
  }

  // Return false if order details are missing or conditions are not met
  return false;
};

const checkOrderByAccessScreen = async () => {
  if (screenName === 'jobSearch' || screenName === 'reApply') {
    const requestParams: TrnShintyokuSelectRequest = {
      orderId: Number(orderId),
    };
    const shintyoku = await getShintyokuNoSrc2Service(requestParams);
    if (shintyoku.totalCount == 0) {
      router.replace({ path: 'mynavi/404' });
    }
  }
};


onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutSideModal);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
      _createElementVNode("div", { class: "c-head-mn u-lg-hidden" }, [
        _createElementVNode("button", {
          onClick: handleBack,
          "aria-label": "戻る"
        }),
        _hoisted_3
      ]),
      _createElementVNode("main", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("p", _hoisted_8, _toDisplayString(companyNameAndJobTitle.value), 1)
        ]),
        _createElementVNode("form", null, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", null, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
                return _createElementVNode("label", {
                  key: n,
                  class: _normalizeClass(["custom-radio-label", { highlighted: n <= applyLevelValue.value }])
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    name: n.toString(),
                    value: n,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((applyLevelValue).value = $event)),
                    class: "real-radio"
                  }, null, 8, _hoisted_11), [
                    [_vModelRadio, applyLevelValue.value]
                  ]),
                  _createElementVNode("span", _hoisted_12, _toDisplayString(n), 1)
                ], 2)
              }), 64)),
              _hoisted_13,
              _hoisted_14
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((applyIdValue).value = $event))
            }, [
              _hoisted_16,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mstApplyList.value, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: item.id,
                  value: item.id
                }, _toDisplayString(item.text), 9, _hoisted_17))
              }), 128))
            ], 512), [
              [_vModelSelect, applyIdValue.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _withDirectives(_createElementVNode("textarea", {
              maxlength: "200",
              placeholder: "メッセージを追加（任意）",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((applyReasonValue).value = $event))
            }, null, 512), [
              [_vModelText, applyReasonValue.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("button", {
              class: "u-modal-open-button js-modal-open-button",
              "data-modal-target": "apply",
              type: "button",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (handleShow(true)))
            }, _hoisted_21),
            _withDirectives(_createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("button", {
                  class: "c-modal_close",
                  type: "button",
                  "aria-label": "閉じる",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (handleLeaveForm()))
                }),
                _createElementVNode("div", _hoisted_24, [
                  _withDirectives(_createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", null, [
                        _hoisted_27,
                        (!isConfirmed.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_28, [
                              _createTextVNode(" 1件応募します。 "),
                              _hoisted_29,
                              _createTextVNode(" よろしいでしょうか？ ")
                            ]))
                          : (_openBlock(), _createElementBlock("p", {
                              key: 1,
                              class: "p-apply-modal_heading",
                              innerHTML: errorMessage.value
                            }, null, 8, _hoisted_30))
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("button", {
                          class: "p-apply-modal_button -apply",
                          type: "button",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (handleSubmitApply()))
                        }, "OK"),
                        _withDirectives(_createElementVNode("button", {
                          class: "p-apply-modal_button",
                          type: "button",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (resetValueRef()))
                        }, " キャンセル ", 512), [
                          [_vShow, !isConfirmed.value]
                        ])
                      ])
                    ])
                  ], 512), [
                    [_vShow, !submitSuccess.value]
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _hoisted_33,
                      _createElementVNode("p", _hoisted_34, _toDisplayString(companyNameAndJobTitle.value), 1),
                      _createElementVNode("div", null, [
                        _createVNode(_component_router_link, {
                          class: "p-apply-modal_button -apply",
                          to: "/apply/"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("応募管理画面へ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_router_link, {
                          class: "p-apply-modal_button -apply",
                          to: "/jobsearch/"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("求人一覧へ")
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ], 512), [
                    [_vShow, submitSuccess.value]
                  ])
                ])
              ]),
              _hoisted_35
            ], 512), [
              [_vShow, showModal.value]
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_36, [
      _createElementVNode("a", {
        class: "g-pagetop",
        href: "#",
        "aria-label": "ページトップへ戻る",
        onClick: _withModifiers(scrollToTop, ["prevent"])
      }, _hoisted_39, 8, _hoisted_37)
    ])
  ]))
}
}

})